import {mapActions, mapMutations} from 'vuex';

import {MARK_TYPES} from '@/utils/viewer/marks';

export default {
  methods: {
    ...mapActions('tasks', ['storeDefectAndViolationTaskWithError']),
    ...mapMutations({showTaskDefectAndViolationForm: 'forms/taskDefectAndViolationForm/SHOW_FORM'}),
    makeTask(mark) {
      switch (mark.type) {
      case MARK_TYPES.DEFECT:
        return this.makeTaskByDefect(mark);
      case MARK_TYPES.UNCONFIRMED_DEFECT:
        return this.makeTaskByUnconfirmedDefect(mark);
      default:
        throw new TypeError('Invalid mark type');
      }
    },
    makeTaskByDefect(mark) {
      let markConfig = {
        defining_point_image_id: this.$route.params.photoId,
        yolo: mark.yolo
      }
      return ({payload}) => this.storeDefectAndViolationTaskWithError({
        taskData: {
          ...markConfig,
          ...payload?.task
        }
      });
    },
    makeTaskByUnconfirmedDefect(mark) {
      let markConfig = {recognition_history_mark_id: mark.id};
      return async ({ payload }) => {
        await this.$api.marks.confirm([mark.id]);
        mark.confirmed = true;

        return this.storeDefectAndViolationTaskWithError({
          taskData: {
            ...markConfig,
            ...payload?.task
          }
        });
      }
    },
    showTaskForm(mark, floor, onClose = null) {
      if (!onClose) onClose = () => {
      };

      const callback = this.makeDefectAndViolationSubmitHandler(mark)

      this.showTaskDefectAndViolationForm({
        onClose,
        task: {},
        floor,
        projectId: this.$route.params.projectId,
        callback
      });
    },
    makeDefectAndViolationSubmitHandler(mark) {
      return this.makeTask(mark);
    }
  }
};

